var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, AfterViewInit } from '@angular/core';
import { FormGroup, FormControl, Validators, } from '@angular/forms';
import { BountyService } from '../../services/bounty.service';
import { UserService } from 'src/app/services/user.service';
export var GAME_MODES = ['osu', 'taiko', 'ctb', 'mania'];
var objectToArray = function (object) {
    return Object.entries(object)
        .map(function (_a) {
        var key = _a[0], val = _a[1];
        return val ? key : null;
    })
        .filter(function (value) { return !!value; });
};
var ɵ0 = objectToArray;
var parseReward = function (amount) {
    return parseFloat(amount.toFixed(2));
};
var ɵ1 = parseReward;
export var transformFormDataToBountyRequest = function (formData) { return (__assign({}, formData, { beatmapGoals: formData.beatmapGoals && objectToArray(formData.beatmapGoals), mods: formData.mods && objectToArray(formData.mods), duration: formData.duration && formData.duration.id, reward: parseReward(formData.reward) * 100, ppType: formData.ppType && formData.ppType.value, paymentType: formData.isPool ? 'pool' : undefined })); };
export var transformValidationErrors = function (errors) { return Object.values(errors).reduce(function (acc, curr) {
    acc.push.apply(acc, curr);
    return acc;
}, []); };
export var durationOptions = [
    { id: 24, name: '1 day' },
    { id: 3 * 24, name: '3 days' },
    { id: 7 * 24, name: '1 week' },
    { id: 30 * 24, name: '30 days' },
    { id: 90 * 24, name: '90 days' },
];
var CreateBountyComponent = /** @class */ (function () {
    function CreateBountyComponent(bountyService, userService) {
        this.bountyService = bountyService;
        this.durationOptions = durationOptions;
        this.duration = this.durationOptions.find(function (o) { return o.name === '30 days'; }); // Duration of hours until bounty ends
        this.ppTypes = [
            { label: 'PP from a single score', value: 'single' },
            { label: 'Total PP', value: 'total' },
        ];
        this.ppType = this.ppTypes[0];
        this.gameModes = GAME_MODES;
        this.gameMode = 'osu';
        this.modeLabels = {
            osu: 'osu! Standard',
            taiko: 'Taiko',
            ctb: 'Catch the Beat',
            mania: 'Mania',
        };
        this.acceptTerms = false;
        this.submitFailed = false;
        this.submitting = false;
        this.success = false;
        this.requiresPayment = false;
        this.parseReward = parseReward;
        this.user = userService.getUser();
    }
    CreateBountyComponent.prototype.ngOnInit = function () {
        this.form = new FormGroup({
            goalType: new FormControl(this.goalType, [Validators.required]),
            beatmapId: new FormControl(this.beatmapId),
            ppType: new FormControl(this.ppType),
            gameMode: new FormControl(this.gameMode, [Validators.required]),
            ppAmount: new FormControl(this.ppAmount),
            tournamentName: new FormControl(this.tournamentName),
            tournamentPlace: new FormControl(this.tournamentPlace),
            duration: new FormControl(this.duration, [
                Validators.required,
                Validators.min(1),
                Validators.max(8760),
            ]),
            acceptTerms: new FormControl(this.acceptTerms, [Validators.requiredTrue]),
        });
        this.updateValidators(this.form.get('goalType').value, true);
    };
    CreateBountyComponent.prototype.ngAfterViewInit = function () { };
    CreateBountyComponent.prototype.changeGoalType = function (goalType) {
        this.form.patchValue({ goalType: goalType });
        this.updateValidators(goalType);
        this.goalType = goalType;
    };
    CreateBountyComponent.prototype.maybeToggleDifficultyReduction = function () {
        var selectedMods = this.form.controls.mods.value;
        var easierModSelected = !!(selectedMods.ez ||
            selectedMods.rx ||
            selectedMods.nf ||
            selectedMods.ht);
        this.form.patchValue({
            beatmapGoals: {
                no_difficulty_reduction: !easierModSelected,
            },
        });
    };
    // Sets and updates all validators (e.g. when goal type is changed)
    CreateBountyComponent.prototype.updateValidators = function (goalType, forceUpdate) {
        if (goalType !== this.goalType || forceUpdate) {
            this.setBeatmapValidators(goalType === 'beatmap');
            this.setPpValidators(goalType === 'pp');
            this.setTournamentValidators(goalType === 'tournament');
            // this.setMissesValidators(goalType);
            // this.setAccuracyValidators(goalType);
            // this.setModValidators(goalType);
            // this.setCustomRuleValidator();
        }
    };
    CreateBountyComponent.prototype.setBeatmapValidators = function (isActive) {
        if (isActive) {
            this.form.controls.beatmapId.setValidators([
                Validators.min(1),
                Validators.max(999999999999999),
                Validators.required,
            ]);
            // this.form.controls.beatmapGoals.setValidators([atLeastOne()]);
        }
        else {
            this.form.controls.beatmapId.clearValidators();
            // this.form.controls.beatmapGoals.clearValidators();
        }
        this.form.controls.beatmapId.updateValueAndValidity();
        // this.form.controls.beatmapGoals.updateValueAndValidity();
    };
    CreateBountyComponent.prototype.setPpValidators = function (isActive) {
        if (isActive) {
            this.form.controls.ppType.setValidators([Validators.required]);
            this.form.controls.ppAmount.setValidators([
                Validators.required,
                Validators.min(1),
                Validators.max(20000),
            ]);
        }
        else {
            this.form.controls.ppType.clearValidators();
            this.form.controls.ppAmount.clearValidators();
        }
        this.form.controls.ppType.updateValueAndValidity();
        this.form.controls.ppAmount.updateValueAndValidity();
    };
    CreateBountyComponent.prototype.setTournamentValidators = function (isActive) {
        if (isActive) {
            this.form.controls.tournamentName.setValidators([
                Validators.required,
                Validators.minLength(2),
                Validators.maxLength(80),
            ]);
            this.form.controls.tournamentPlace.setValidators([
                Validators.required,
                Validators.min(1),
                Validators.max(128),
            ]);
        }
        else {
            this.form.controls.tournamentName.clearValidators();
            this.form.controls.tournamentPlace.clearValidators();
        }
        this.form.controls.tournamentName.updateValueAndValidity();
        this.form.controls.tournamentPlace.updateValueAndValidity();
    };
    CreateBountyComponent.prototype.isGoalType = function (goalType) {
        return this.form.get('goalType').value === goalType;
    };
    // public getFormValidationErrors() {
    //   Object.keys(this.form.controls).forEach(key => {
    //     const controlErrors: ValidationErrors = this.form.get(key).errors;
    //     if (controlErrors) {
    //       console.log(key, controlErrors);
    //     }
    //   });
    // }
    CreateBountyComponent.prototype.hasError = function (controlKey) {
        var control = this.form.get(controlKey);
        var touchedOrSubmitted = !control.pristine || this.submitFailed;
        return control.errors && touchedOrSubmitted;
    };
    CreateBountyComponent.prototype.submitForm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var formData, dataTransformed, _a, bounty, requiresPayment, e_1, error;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.form.valid) {
                            this.submitFailed = true;
                            return [2 /*return*/];
                        }
                        this.submitting = true;
                        this.errors = undefined;
                        formData = this.form.value;
                        dataTransformed = transformFormDataToBountyRequest(formData);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.bountyService.create(dataTransformed)];
                    case 2:
                        _a = _b.sent(), bounty = _a.bounty, requiresPayment = _a.requiresPayment;
                        this.bounty = bounty;
                        this.requiresPayment = requiresPayment;
                        this.success = true;
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _b.sent();
                        if (e_1.error && e_1.error.errors) {
                            this.errors = transformValidationErrors(e_1.error.errors);
                        }
                        else {
                            error = e_1.status === 401
                                ? 'You are not logged in. Please log in and try again.'
                                : 'A server error occured';
                            this.errors = [error];
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        this.submitting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    return CreateBountyComponent;
}());
export { CreateBountyComponent };
export { ɵ0, ɵ1 };
